// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$collegeApiService = {
      college_api_url: `${process.env.VUE_APP_COURSE_API_URL}/colleges`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.college_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 取得最新一期的學院
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getLatestSession(additional = '') {
        const url = `${this.college_api_url}/latest-session`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      },

      /**
       * 透過 ID 取得學院
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getById(id, additional = '') {
        const url = `${this.college_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        
        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
